import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Clock, ArrowUpRight } from "lucide-react";
import { SERVICES, PLANITY_URL } from "../../data/content";
import { Reveal } from "./Reveal";

export const Services = () => {
  return (
    <section
      id="prestations"
      data-testid="services"
      className="bg-[#f6f1e9]"
    >
      <div className="max-w-6xl mx-auto px-6 pt-10 md:pt-14 pb-20 md:pb-10">
        <Reveal className="text-center max-w-2xl mx-auto mb-14 md:mb-20">
          <p className="text-xs tracking-[0.3em] uppercase text-[#b07a63] mb-5">
            La carte
          </p>
          <h2 className="font-serif-display font-light text-[#4b2018] text-4xl md:text-6xl">
            Prestations
          </h2>
          <p className="mt-5 text-[#4b2018] leading-relaxed">
            Des soins pensés pour répondre à vos envies du moment.
          </p>
          <p
            data-testid="services-clickable-hint"
            className="mt-6 text-xs tracking-wide text-[#b07a63]/80"
          >
            Cliquez sur les images pour découvrir chaque prestation.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-6 md:gap-8">
          {SERVICES.map((s, i) => {
            const to = s.link || `/prestations/${s.slug}`;
            return (
            <motion.article
              key={s.name}
              data-testid={`service-item-${i}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-70px" }}
              transition={{ duration: 1.1, delay: (i % 2) * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="group flex flex-col bg-white rounded-md overflow-hidden border border-[#ece4d7] hover:shadow-[0_20px_40px_-24px_rgba(43,42,39,0.35)] transition-shadow duration-500"
            >
              <Link
                to={to}
                data-testid={`service-image-link-${i}`}
                aria-label={`Découvrir ${s.name}`}
                className="relative block aspect-[4/3] overflow-hidden"
              >
                <img
                  src={s.image}
                  alt={`${s.name} à Toulouse — Ninaa Beauty`}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                />
                {!s.hideBadge && (
                  <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-white/90 backdrop-blur px-3 py-1 text-xs text-[#4b2018]">
                    <Clock size={13} className="text-[#b07a63]" /> {s.duration}
                  </span>
                )}
                <div className="absolute inset-0 flex items-center justify-center bg-[#2b2a27]/35 opacity-0 group-hover:opacity-100 group-active:opacity-100 group-focus-within:opacity-100 transition-opacity duration-500">
                  <span className="inline-flex items-center gap-2 rounded-full border border-white/70 bg-white/10 backdrop-blur-sm px-5 py-2.5 text-sm tracking-wide text-white translate-y-1 group-hover:translate-y-0 group-active:translate-y-0 transition-transform duration-500">
                    Découvrir <ArrowUpRight size={15} />
                  </span>
                </div>
              </Link>

              <div className="flex flex-col flex-1 p-6">
                <Link
                  to={to}
                  className="font-serif-display text-2xl text-[#4b2018] leading-tight hover:text-[#b07a63] transition-colors"
                >
                  {s.name}
                </Link>
                <p className="mt-2 text-sm text-[#4b2018] leading-relaxed">
                  {s.desc}
                </p>

                <a
                  href={PLANITY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`reserve-btn-${i}`}
                  className="mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-[#4e231b] text-white px-5 py-3 text-sm hover:bg-[#b07a63] transition-colors duration-400"
                >
                  Réserver
                  <ArrowUpRight size={16} />
                </a>
              </div>
            </motion.article>
            );
          })}
        </div>

        <p className="mt-10 text-center text-sm text-[#4b2018] italic">
          Chaque soin peut être adapté à vos besoins — parlons-en lors de votre
          rendez-vous.
        </p>
      </div>
    </section>
  );
};
